import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

import FacebookIcon from './icons/square-facebook.svg';
import TwitterIcon from './icons/square-twitter.svg';
import InstagramIcon from './icons/square-instagram.svg';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-section footer-site-map">
                    <h5>Site Map</h5>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/browse">Browse Vet Bills</Link></li>
                        <li><Link to="/about">About</Link></li>
                        <li><Link to="/help">Help/FAQ</Link></li>
                        <li><Link to="/support">Support</Link></li>
                    </ul>
                </div>
                <div className="footer-section">
                    <h5>Policies</h5>
                    <ul>
                        <li><Link to="/privacy">Privacy Policy</Link></li>
                        <li><Link to="/terms">Terms of Service</Link></li>
                    </ul>
                </div>
                <div className="footer-section contact-info">
                    <h5>Contact Us</h5>
                    <p><span>Email:</span> <a href="mailto:info@getvetbill.com">info@getvetbill.com</a></p>
                </div>
                <div className="footer-section social-media">
                    <h5>Follow Us</h5>
                    <Link to="#" target="_blank" rel="noreferrer">
                        <img src={FacebookIcon} alt="Facebook" />
                    </Link>
                    <Link to="#" target="_blank" rel="noreferrer">
                        <img src={TwitterIcon} alt="Twitter" />
                    </Link>
                    <Link to="#" target="_blank" rel="noreferrer">
                        <img src={InstagramIcon} alt="Instagram" />
                    </Link>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {currentYear} VetBill. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
